import Box from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import { DesignStatus } from '~/utils/constants';

function getColorByStatus(theme: Theme, status?: string) {
  const { palette } = theme;
  if (!status) return 'transparent';
  if (status === DesignStatus.DESIGN_READY) return '#81C784';
  if (status === DesignStatus.CHANGES_REQUESTED) return '#F0BF80';
  if (status === DesignStatus.APPROVED) return palette.primary.light;

  return palette.grey[300];
}

export default function DesignStatusChip({ status, ...props }: TypographyProps & { status?: string }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      px="6px"
      py="3px"
      borderRadius={1}
      width="fit-content"
      bgcolor={(theme) => getColorByStatus(theme, status)}
      minHeight={24}
      {...props}
    >
      <Typography variant="caption" fontSize={10} fontWeight={500} lineHeight="18px">
        {status}
      </Typography>
    </Box>
  );
}
